import { DeviceContext } from "./shared";
import WebImpl from "./web";

export default class DesktopImpl extends WebImpl {
	public readonly platform = DeviceContext.DESKTOP;
}
